module.exports = __webpack_public_path__ + "c4e58e45a4ad28b20ff211385d48647f.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/751.png
// module id = 1690
// module chunks = 2